/**
 * JWT payload structure from auth-service
 * All fields optional as payload structure varies by token type
 */
export interface JwtPayload {
  auth?: string;
  authUserId?: number;
  uuid?: string;
  iss?: string;
  aud?: string;
  auth_time?: number;
  user_id?: string;
  sub?: string;
  iat?: number;
  exp?: number;
  email?: string;
  email_verified?: boolean;
  firebase?: {
    identities?: {
      email?: string[];
    };
    sign_in_provider?: string;
  };
}

/**
 * Decode JWT token and return raw payload
 *
 * @param token - JWT token string
 * @returns Decoded payload or null if invalid
 */
export function decodeJwtToken(token: string | undefined): JwtPayload | null {
  if (!token) {
    return null;
  }

  try {
    const parts = token.split('.');

    if (parts.length !== 3) {
      return null;
    }

    const payload = parts[1];
    const decoded = Buffer.from(payload, 'base64').toString('utf-8');
    const parsed: JwtPayload = JSON.parse(decoded);

    return parsed;
  } catch {
    return null;
  }
}
